import { AuthService, getErrorMessage } from '@/services/auth/auth_service'
import { Button, Card, message, Typography, Form, Input } from 'antd'
import { useState } from 'react';

const { Title } = Typography

export default function LoginScreen() {

    const [loading, setLoading] = useState(false);

    async function handleEmailLogin(values: { email: string; password: string }) {
        setLoading(true);
        try {
            await AuthService.getInstance().signInWithEmailAndPassword(values.email, values.password);
        } catch (error: unknown) {
            console.error(error);
            const errorMessage = getErrorMessage(error);
            message.error({
                content: errorMessage,
                duration: 6,
            });
        }
        setLoading(false);
    }

    return (
        <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Card style={{ width: 450, margin: "0 auto" }}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginBottom: 15
                }}>
                    <img src='/assets/logo_full.png' width={250} />
                </div>
                <div className='text-center'>
                    <Title level={1}>Willkommen!</Title>
                </div>

                <div style={{ marginTop: 24 }}>
                    <Form onFinish={handleEmailLogin} layout="vertical" size="large">
                        <Form.Item
                            name="email"
                            label="E-Mail"
                            rules={[
                                { required: true, message: 'Bitte geben Sie Ihre E-Mail ein!' },
                                { type: 'email', message: 'Bitte geben Sie eine gültige E-Mail ein!' }
                            ]}
                            style={{ marginBottom: 16 }}
                        >
                            <Input
                                placeholder="ihre.email@beispiel.de"
                                style={{
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    fontSize: '16px'
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            label="Passwort"
                            rules={[{ required: true, message: 'Bitte geben Sie Ihr Passwort ein!' }]}
                            style={{ marginBottom: 8 }}
                        >
                            <Input.Password
                                placeholder="Ihr Passwort"
                                style={{
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    fontSize: '16px'
                                }}
                            />
                        </Form.Item>
                        {/* <div className='text-right' style={{ marginBottom: 20 }}>
                            <Button
                                type="link"
                                onClick={() => setResetModalOpen(true)}
                                style={{ padding: 0, fontSize: '14px', color: '#666' }}
                            >
                                Passwort vergessen?
                            </Button>
                        </div> */}
                        <Form.Item>
                            <Button
                                className='mt-5'
                                type='primary'
                                htmlType="submit"
                                loading={loading}
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                }}
                            >
                                Anmelden
                            </Button>
                        </Form.Item>
                    </Form>
                </div>

            </Card>
        </div>
    )
}
